import type React from "react";
import { useState } from "react";
import { useCreateComment } from "@/hooks/channel/useCreateComment";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/hooks/ui/use-toast";
import { useAuth } from "@/hooks/useAuth";

interface CommentFormProps {
	postId: string;
}

export const CommentForm: React.FC<CommentFormProps> = ({ postId }) => {
	const [content, setContent] = useState("");
	const { createComment, loading } = useCreateComment();
	const { toast } = useToast();
	const { user } = useAuth();

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (!content.trim() || !user) return;

		try {
			await createComment({
				postId,
				content: content.trim(),
			});
			setContent("");
			toast({
				title: "コメントを投稿しました",
				variant: "default",
			});
		} catch (error) {
			toast({
				title: "コメントの投稿に失敗しました",
				variant: "destructive",
			});
		}
	};

	return (
		<form onSubmit={handleSubmit} className="space-y-2">
			<Textarea
				value={content}
				onChange={(e) => setContent(e.target.value)}
				placeholder="コメントを入力..."
				className="min-h-[80px]"
			/>
			<div className="flex justify-end">
				<Button
					type="submit"
					size="sm"
					disabled={loading || !content.trim() || !user}
				>
					{loading ? "送信中..." : "コメントする"}
				</Button>
			</div>
		</form>
	);
};
